import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { Route, Routes, Navigate } from 'react-router-dom';

import PrivateRoute from 'containers/PrivateRoute';
import ContentLayout from 'containers/components/layouts/ContentLayout';
import {
    canAccessEmailCampaigns,
    canAccessSalesCampaigns,
    getCampaignsDefaultRoute,
} from './utils/campaignPermissions';
import CampaignsHeader from './CampaignsHeader';
import ActivityCampaigns from './ActivityCampaigns';
import MarketingCampaigns from './MarketingCampaigns';

import './styles.scss';

const Main = memo(() => {
    const login = useSelector((state) => state.config.login);
    const hasSalesCampaigns = useSelector(canAccessSalesCampaigns);
    const hasEmailCampaigns = useSelector(canAccessEmailCampaigns);
    const defaultRoute = useSelector(getCampaignsDefaultRoute);
    const canAccessCampaigns = hasSalesCampaigns || hasEmailCampaigns;

    if (!login) return null;

    if (!canAccessCampaigns) {
        return <Navigate to="/" replace />;
    }

    return (
        <ContentLayout header={<CampaignsHeader />}>
            <Routes>
                <Route path="/" element={<Navigate to={defaultRoute} replace />} />
                <Route
                    path="/activity/*"
                    element={
                        <PrivateRoute
                            isAllowed={hasSalesCampaigns}
                            redirectTo="/campaigns/marketing"
                        >
                            <ActivityCampaigns />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/marketing/*"
                    element={
                        <PrivateRoute
                            isAllowed={hasEmailCampaigns}
                            redirectTo="/campaigns/activity"
                        >
                            <MarketingCampaigns />
                        </PrivateRoute>
                    }
                />
            </Routes>
        </ContentLayout>
    );
});

export default Main;
